// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5872":"css/app.6970","8731":"css/admin-app.6970"}[chunkId] + ".css";
};